import { ValidateVerdictFormValues } from './validateVerdictFormTypes';

export const buildValidateVerdictFormData = (formValues: ValidateVerdictFormValues) => {
  const formData = new FormData();
  formData.append('signedVerdictFile', formValues.signedVerdictFile!);
  return formData;
};
